import * as React from 'react'
import { BottleneckMessage } from '../../domain/BottleneckMessage'

interface Props {
    message?: BottleneckMessage
}

export default class Xdebug extends React.PureComponent<Props> {
    render = () => (
        <div>
            <p>The Xdebug PHP extension is loaded.</p>

            <p>Xdebug is a Debugger and Profiler suitable for use during development and only selectively in production.</p>

            <p>
                It can slow down your applications by a factor of two, <i>even when it is only enabled and not actually used</i>. If you
                don&apos;t need xdebug in production, you should disable it by commenting the following line in your php.ini file:
            </p>

            <pre>
                <code>;zend_extension=xdebug.so ; Add a hash to comment</code>
            </pre>

            <p>Don&apos;t forget to restart Apache or PHP-FPM webserver afterwards.</p>
        </div>
    )
}
